import type { CSSProperties } from 'react'
import type { BookingStatus } from '@/shared/api'
import { cn } from '@/shared/lib/cn'
import { statusToken } from '../model/status'
import s from './BookingStatusChip.module.css'

type BookingStatusChipProps = {
  status: BookingStatus
  /** Готовая подпись с сервера (`statusLabel`) — фронт текст статуса не переводит и не сочиняет. */
  label: string
  size?: 'sm' | 'md'
}

/**
 * Чип статуса брони. Две геометрии из макета (prototype/Prototype.dc.html): `sm` — строка
 * таблицы броней (строка 588, h24, без обводки), `md` — шапка карточки брони (строка 1491,
 * h26, с обводкой и более насыщенной заливкой). Токен цвета приходит инлайн-переменной
 * `--tint`, поэтому один и тот же компонент красится под любой статус без веток в CSS.
 */
export function BookingStatusChip({ status, label, size = 'sm' }: BookingStatusChipProps) {
  return (
    <span
      className={cn(s.root, size === 'md' ? s.md : s.sm)}
      style={{ '--tint': statusToken(status) } as CSSProperties}
    >
      <span className={s.dot} />
      {label}
    </span>
  )
}
